import React,{useState,useEffect,}from 'react'
import { Table,Space, Flex,} from 'antd';
import { useClientListQuery,} from '../../store/ReactWebSiteApi';
import { clientListRows, CLIENT_LIST_QUERY_PAGE } from './clientListUtil';
import ClientAdd from './ClientAdd';
import Main from '../../cpn/Main';
import {DeleteOutlined,LogoutOutlined} from '@ant-design/icons';
import ClientQuery from './ClientQuery';
import ClientEdit from './ClientEdit';
import ClientDel from './ClientDel';
function ClientList() {
    const [query,setQuery] = useState({
        ec_e_id:localStorage.getItem('e_id'),
        ec_action:'search',
        ec_type_id:'',
        ec_name:'',
        ec_content:'',
        ec_uid:'',
        ec_mode:'1',
        ec_state:'2',
        ...CLIENT_LIST_QUERY_PAGE,
    })
    const {data,isSuccess} = useClientListQuery(query,{refetchOnMountOrArgChange:1})
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                const rows = clientListRows(data.Result);
                const newArr = rows.map(item => {
                    const {ec_id:key,ec_name,ec_num,ec_content,ec_uname,ec_ctime,finance_num,ec_type_id,ect_name,ec_update_ctime,ec_update_uname,ec_state} = item;
                    return item = {key,ec_name,ec_num,ec_content,ec_uname,ec_ctime,finance_num,ec_type_id,ect_name,ec_update_ctime,ec_update_uname,ec_state}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.ec_ctime;
                    let bTimeString = b.ec_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])       
    const columns = [
              
        {
            key: 'type',
            title: '客户名称',
            dataIndex: 'ec_name',
        },
        {
            key: 'ec_content',
            title: '备注',
            dataIndex: 'ec_content',
        },
        {
            key: 'ect_name',
            title: '客户类型',
            dataIndex: 'ect_name',
        },
        {
            key: 'num',
            title: '收支数量',
            dataIndex: 'finance_num',
        },
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key'
        }, 
        // {
        //     key: 'time',
        //     title: '记录',
        //     render: (_,record) => {
        //         return <>
        //             <div>{record.ec_ctime + record.ec_uname}新建</div>
        //             {record.ec_update_ctime && <div>{record.ec_update_ctime + record.ec_update_uname}修改</div>}
        //         </>
        //     }
        // },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>                        
                        <ClientEdit
                            ec_id={record.key}
                            ec_state={record.ec_state}
                        />
                        <ClientDel
                            ec_id={record.key}
                            ec_state={record.ec_state}
                            ec_name={record.ec_name}
                        />              
                    </Space>
                    
                </>
            }
        },
    ]


    return (
        <Main t1='客户'>
             {query.ec_state==='2' ? <Flex justify='space-between' align='center'>
                                        <Space>                
                                            <ClientAdd getNewClient={() => {}} type='primary'/>                
                                            <ClientQuery
                                                getClientQuery={(e) => {
                                                    setQuery(prevState=>({
                                                        ...prevState,
                                                        ec_type_id:e.ec_type_id,
                                                        ec_name:e.ec_name,
                                                        ec_content:e.ec_content,
                                                        ec_uid:e.ec_uid,
                                                    }))
                                                }}
                                            />                                            
                                        </Space><a 
                                                style={{
                                                    marginRight:"20px",
                                                    fontSize:"18px"
                                                }}
                                                onClick={() => {
                                                    setQuery(prevState=>({...prevState,ec_state:'1'}))
                                                }}
                                            ><DeleteOutlined /> 已删除客户</a>
                                        </Flex>:<Flex>
                                            <a 
                                                style={{
                                                    fontSize:"18px"
                                                    }}
                                                onClick={() => {
                                                    setQuery(prevState=>({...prevState,ec_state:'2'}))
                                                }}
                                            ><LogoutOutlined /> 未删除客户</a>
                                        </Flex>}
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{showSizeChanger:true,defaultPageSize:'20',showTotal:(total) => `共${total}条`}} 
                style={{marginTop:"20px"}}
            />        
        </Main>
    )
}

export default ClientList